import { EntityLayout } from '@backstage/plugin-catalog';
import {
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
} from '@backstage/plugin-org';
import { default as Grid } from '@mui/material/Grid2';
import { entityWarningContent } from './common';

export const groupPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        {entityWarningContent}
        <Grid size={6}>
          <EntityGroupProfileCard />
        </Grid>
        <Grid size={6}>
          <EntityOwnershipCard />
        </Grid>
        <Grid size={12}>
          <EntityMembersListCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
